// One primary button in honey; ink for money; quiet is a card; ghost is text.
// A price rides on the button that spends, once, as a lighter suffix.
import type { ButtonHTMLAttributes } from 'react';
import { Icon, type IconName } from './Icon';
import { cx } from './cx';

export type ButtonVariant = 'honey' | 'ink' | 'quiet' | 'ghost';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: 'base' | 'small';
  wide?: boolean;
  icon?: IconName;
  /** What the press spends: "about 31¢". */
  price?: string;
}

export function Button({ variant = 'quiet', size = 'base', wide, icon, price, className, type = 'button', children, ...rest }: ButtonProps) {
  return (
    <button type={type} className={cx('btn', variant, size === 'small' && 'small', wide && 'wide', className)} {...rest}>
      {icon && <Icon name={icon} />}
      {children}
      {price && <span className="price">· {price}</span>}
    </button>
  );
}
